// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"CellContextMenu_contextMenu__3En3-","menuItem":"CellContextMenu_menuItem__1GYqy"};